<template>
  <div class="shopOptionItem itemQuantity">
    <p class="optionLabel">{{ locale.quantity }}</p>
    <div class="quantity">
      <button
        type="button"
        class="btnMinus"
        :disabled="quantity <= min"
        @click.stop="decrease">
      </button>
      <span class="qty">{{ quantity }}{{ locale.unit_item }}</span>
      <button
        type="button"
        class="btnPlus"
        :disabled="quantity >= max"
        @click.stop="increase">
      </button>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'shopDetailQuantity',
  props: [
    'locale',
    'shopItemId',
    'detailItemInfo'
  ],
  computed: {
    siteCommon () {
      return this.$store.getters['common/getSetting']
    }
  },
  watch: {
    quantity (quantity) {
      this.$store.commit('shop/setDetailItemQuantity', quantity)
    }
  },
  created () {
    if (this.detailItemInfo) {
      if (this.detailItemInfo.price) {
        this.price = this.detailItemInfo.price
      }
      if (this.detailItemInfo.selectQuantity) {
        const min = Number(this.detailItemInfo.selectQuantity.min)
        const max = Number(this.detailItemInfo.selectQuantity.max)
        this.min = min
        this.max = max
        if (!this.detailItemInfo.selectOptionByQuantity) {
          this.quantity = min
        }
      }
    }
  },
  data () {
    return {
      min: 1,
      max: 10,
      quantity: 1,
      price: null
    }
  },
  methods: {
    increase () {
      this.quantity = this.quantity >= this.max ? this.max : this.quantity + 1
    },
    decrease () {
      this.quantity = this.quantity <= this.min ? this.min : this.quantity - 1
    }
  }
}
</script>